import {
  ContentLayout,
  HeaderBreadcrumbs,
  LoadingButton,
  Loader,
} from "../../../shared";
import * as React from "react";
import {
  Button,
  Stack,
  Typography,
  Grid,
  Card,
  Divider,
  Skeleton,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useAddorEditStampCard } from "../hooks";
import { StampCardGeneralDetails } from "../";

export const AddorEditStampCard = () => {
  const navigate = useNavigate();
  const {
    state,
    globalData,
    validator,
    handleInputChange,
    handleDescriptionChange,
    handleSubmit,
    breadcrumbLinks,
    isEditMode,
    forceUpdate,
  } = useAddorEditStampCard();

  const { name, description, total_stamps, cycle_validity } = state.data;

  return (
    <>
      {validator.current.purgeFields()}
      <ContentLayout
        title={isEditMode ? "Edit Stamp Card" : "New Stamp Card"}
        breadcrumbs={<HeaderBreadcrumbs links={breadcrumbLinks} />}
        rightContent={
          <LoadingButton
            variant={isEditMode ? "contained" : "text"}
            color="primary"
            // sx={{ background: "#F5F8FF", color: "#3B6DD8" }}
            loading={state.isSaving}
            onClick={() => handleSubmit(true)}
          >
            {isEditMode ? "Save" : "Save as Draft"}
          </LoadingButton>
        }
      >
        {state.isLoading ? (
          <Loader />
        ) : (
          <Card sx={{ p: "32px 24px", mb: "24px" }}>
            <Grid container spacing={3}>
              {/* Stamp Card Name */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Stamp Card Name
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="20px">
                  <InputControl
                    name="name"
                    label="Stamp Card Name"
                    autoComplete="off"
                    value={name}
                    onChange={handleInputChange}
                    required
                    error={validator.current.message("name", name, "required")}
                    helperText={validator.current.message(
                      "name",
                      name,
                      "required",
                    )}
                  />
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              {/* Description */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Short Description
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="2px">
                  <InputControl
                    type="textarea"
                    rows={4}
                    name="description"
                    label="Short Description"
                    value={description}
                    onChange={handleInputChange}
                    required
                    error={validator.current.message(
                      "description",
                      description,
                      "required",
                    )}
                    helperText={validator.current.message(
                      "description",
                      description,
                      "required",
                    )}
                  />
                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: "4px",
                      alignItems: "center",
                      padding: "6px 4px",
                    }}
                  >
                    <img
                      style={{
                        height: "14px",
                      }}
                      alt="details"
                      src="/icons/ic_info.svg"
                    />
                    <Typography
                      variant="caption"
                      lineHeight="15px"
                      color="#666666"
                    >
                      Pre-cycle message displayed in Online Ordering (App & Web) under Coffee Card.
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              {/* Total Stamps */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Total Stamps
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="20px">
                  <InputControl
                    name="total_stamps"
                    label="Total Stamps"
                    type="number"
                    autoComplete="off"
                    value={total_stamps}
                    onChange={handleInputChange}
                    required
                    error={validator.current.message(
                      "total_stamps",
                      total_stamps,
                      "required|numeric",
                    )}
                    helperText={validator.current.message(
                      "total_stamps",
                      total_stamps,
                      "required|numeric",
                    )}
                  />
                </Stack>
              </Grid>

              <Divider sx={{ width: "100%", mt: 3 }} />

              {/* Cycle Validity */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Cycle Validity
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Stack width="100%" gap="6px">
                  <InputControl
                    name="cycle_validity"
                    label="Cycle Validity (Days)"
                    type="number"
                    autoComplete="off"
                    value={cycle_validity}
                    onChange={handleInputChange}
                    required
                    error={validator.current.message(
                      "cycle_validity",
                      cycle_validity,
                      "required|numeric",
                    )}
                    helperText={validator.current.message(
                      "cycle_validity",
                      cycle_validity,
                      "required|numeric",
                    )}
                  />
                  <Stack
                    sx={{
                      flexDirection: "row",
                      gap: "4px",
                      alignItems: "center",
                      padding: "6px 4px",
                    }}
                  >
                    <img
                      style={{
                        height: "14px",
                      }}
                      alt="details"
                      src="/icons/ic_info.svg"
                    />
                    <Typography
                      variant="caption"
                      lineHeight="15px"
                      color="#666666"
                    >
                      Set how long a stamp cycle stays active from the first
                      stamp.
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Card>
        )}
      </ContentLayout>
    </>
  );
};
